var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.391833 4.94069C0.499579 5.17969 0.73742 5.33335 0.9996 5.33335H8.99959C9.26179 5.33335 9.49959 5.17962 9.60739 4.94062C9.71513 4.70162 9.67273 4.42163 9.49913 4.22517L9.49806 4.22399C9.47433 4.19741 9.40666 4.12175 9.36493 4.07572C9.28019 3.98227 9.15853 3.84937 9.00939 3.69013C8.71173 3.37227 8.30186 2.94651 7.85646 2.51903C7.41393 2.09427 6.92293 1.65486 6.46453 1.31735C6.23579 1.1489 6.00079 0.995127 5.77333 0.880867C5.55959 0.773494 5.28659 0.666687 4.99959 0.666687C4.71253 0.666687 4.43953 0.773487 4.22579 0.88086C3.99833 0.99512 3.76339 1.1489 3.5346 1.31735C3.07621 1.65486 2.58521 2.09429 2.14267 2.51905C1.69728 2.94653 1.28743 3.37229 0.989753 3.69016C0.840626 3.84941 0.718966 3.98231 0.634273 4.07575C0.592386 4.12197 0.524626 4.19773 0.501119 4.22401L0.500346 4.22488C0.326726 4.42134 0.284079 4.70162 0.391833 4.94069Z",
    fill: "#C3C4C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttSortUp);
export default __webpack_public_path__ + "static/media/gantt-sort-up.c2c3be11c36b900743296e2c5f6c233c.svg";
export { ForwardRef as ReactComponent };